import type { ValidatedAddressMetadata } from '../../../types';
import GatewayAxiosClient from '../GatewayAxiosClient';
import type {
  FetchZip3DistanceFilterParams,
  FulfillmentCenterCarrierSchedule,
  GenerateGeolocationMetadataPayload,
} from './types';
import { getToken } from '../../session';
export class FulfillmentConfigService {
  public async generateGeolocationMetadata(
    payload: GenerateGeolocationMetadataPayload,
  ): Promise<ValidatedAddressMetadata> {
    return (await GatewayAxiosClient.post('/address/metadata', payload)).data;
  }

  public async fetchZip3Distances(filterParams?: FetchZip3DistanceFilterParams) {
    const res = await GatewayAxiosClient.get(`/fulfillment-center/distances/${filterParams?.zip3}`, {
      params: filterParams,
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }

  public async fetchCarrierSchedules(partnerId: string): Promise<FulfillmentCenterCarrierSchedule[]> {
    const res = await GatewayAxiosClient.get(`/fulfillment-center/carrier-schedules/${partnerId}`, {
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }
}
